import { useMemo, useState } from 'react';

import useFacilities, { SSRFacilityContextType } from '@/services/useFacilitiesSSR';

import { ExtendedFacilities, FacilityContext, IFacilityContextProvider } from './FacilityContextProvider.ctx';

export function FacilityContextProvider({
	brand,
	user,
	facilityCode,
	children,
	defaultToCdn = false,
	disableFacilityFetching = false,
	ssrData = null,
}: Readonly<IFacilityContextProvider & { ssrData?: SSRFacilityContextType | null }>) {
	const [shouldFetchNearbyFacility, setShouldFetchNearbyFacility] = useState(!disableFacilityFetching);
	const facilities = useFacilities(brand, user, facilityCode, defaultToCdn, shouldFetchNearbyFacility, ssrData);

	// Extend facilities with lazy initialization support
	const extendedFacilities: ExtendedFacilities = useMemo(
		() => ({
			...facilities,
			facilityCode: facilities.facilityCode,
			shouldFetchNearbyFacility,
			initialize: () => {
				if (!shouldFetchNearbyFacility) {
					setShouldFetchNearbyFacility(true);
				}
			},
		}),
		[facilities, shouldFetchNearbyFacility]
	);

	return <FacilityContext.Provider value={extendedFacilities}>{children}</FacilityContext.Provider>;
}
